"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var formik_1 = require("formik");

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var __1 = require("..");

var enums_1 = require("../../enums");

var store_1 = require("../../store");

var validation_1 = require("../../validation");

var styled_1 = require("../styled");

var FormikConnected_1 = __importDefault(require("./FormikConnected"));

var TermsAndConditionsBox_1 = __importDefault(require("./TermsAndConditionsBox"));

var TITLES = ['Create a Username and Password', 'Let’s know each other'];

var UserNameRegistrationFormComponent =
/** @class */
function (_super) {
  __extends(UserNameRegistrationFormComponent, _super);

  function UserNameRegistrationFormComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.setPageTitle = function (activeStep) {
      var setPageTitle = _this.props.setPageTitle;
      var title = TITLES[activeStep];
      setPageTitle(title);
    };

    _this.validateUserName = function (props) {
      var validUserNameCheck = _this.props.validUserNameCheck;
      var errors = props.errors,
          setFieldTouched = props.setFieldTouched,
          setFieldValue = props.setFieldValue,
          setSubmitting = props.setSubmitting,
          currentUserName = props.values.userName;
      var _a = _this.props.userNameValidation,
          userName = _a.userName,
          userNameAvailable = _a.userNameAvailable,
          validated = _a.validated;
      setFieldTouched(enums_1.FieldNames.userName);

      if (currentUserName && currentUserName !== userName && !errors.userName) {
        setSubmitting(true);
        validUserNameCheck(currentUserName);
      } else if (currentUserName === userName && validated) {
        setFieldValue(enums_1.FieldNames.emailValid, userNameAvailable);
        setSubmitting(false);
      }
    };

    _this.onUserNameChanged = function (props) {
      props.setFieldValue(enums_1.FieldNames.userNameValid, true);
    };

    return _this;
  }

  UserNameRegistrationFormComponent.prototype.componentDidMount = function () {
    this.setPageTitle(this.props.activeStep);
  };

  UserNameRegistrationFormComponent.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.activeStep !== this.props.activeStep) {
      this.setPageTitle(this.props.activeStep);
    }
  };

  UserNameRegistrationFormComponent.prototype.onUserNameValidationStateChange = function (prevUserNameValidation, nextUserNameValidation, formikProps) {
    var setFieldValue = formikProps.setFieldValue,
        setSubmitting = formikProps.setSubmitting;
    var prevUserName = prevUserNameValidation.userName,
        prevValidatedUserNameChecked = prevUserNameValidation.validated;
    var nextUserName = nextUserNameValidation.userName,
        validatedUserNameAvailable = nextUserNameValidation.userNameAvailable,
        validatedUserNameChecked = nextUserNameValidation.validated;

    if (prevUserName === nextUserName && validatedUserNameChecked !== prevValidatedUserNameChecked) {
      setFieldValue(enums_1.FieldNames.userNameValid, validatedUserNameAvailable);
      setSubmitting(false);
    } else if (prevUserName !== nextUserName) {
      setSubmitting(true);
    }
  };

  UserNameRegistrationFormComponent.prototype.isContinueButtonDisabled = function (props) {
    var errors = props.errors,
        touched = props.touched;
    var _a = this.props.userNameValidation,
        validated = _a.validated,
        userNameAvailable = _a.userNameAvailable;
    var userNameCheckedAndAvailable = validated && userNameAvailable;
    var signupCodeParamAvailable = false;
    var params = core_1.locationWebService.parseQueryParams(core_1.locationWebService.location.search);

    if (params && Object.keys(params).length > 0) {
      signupCodeParamAvailable = true;
    }

    if (signupCodeParamAvailable === true) {
      return !touched.userName || !userNameCheckedAndAvailable || !(props.touched.userName && userNameCheckedAndAvailable && !errors.userName && !errors.userNameValid && !errors.password && !errors.passwordConfirm && !errors.termsAccepted && props.values.complianceTermsAccepted);
    }

    return !touched.userName || !userNameCheckedAndAvailable || !(props.touched.userName && userNameCheckedAndAvailable && !errors.userName && !errors.userNameValid && !errors.password && !errors.passwordConfirm && !errors.termsAccepted);
  };

  UserNameRegistrationFormComponent.prototype.setInitialAvatarValue = function (dirty, values) {
    var avatars = this.props.avatars;

    if (!dirty) {
      return avatars[0] ? avatars[0].id : '';
    }

    return values.avatar;
  };

  UserNameRegistrationFormComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        previousHandler = _a.previousHandler,
        nextHandler = _a.nextHandler,
        activeStep = _a.activeStep,
        MaskedInputDate = _a.screenProps.components.MaskedInputDate,
        initialValues = _a.initialValues,
        navigation = _a.navigation,
        showTerms = _a.showTerms,
        showComplianceTerms = _a.showComplianceTerms,
        avatars = _a.avatars,
        activeBreakpoint = _a.activeBreakpoint,
        userNameValidation = _a.userNameValidation,
        updating = _a.updating,
        _onSubmit = _a.onSubmit;
    var userName = userNameValidation.userName,
        validated = userNameValidation.validated;
    var waitingForUserNameValidation = !!userName && !validated;
    return react_1.default.createElement(formik_1.Formik, {
      initialValues: initialValues,
      onSubmit: function onSubmit(values, _a) {
        var setSubmitting = _a.setSubmitting;
        setSubmitting(true);

        _onSubmit(values);
      },
      validationSchema: validation_1.userNameRegistrationValidationSchema,
      render: function render(props) {
        var dirty = props.dirty,
            values = props.values;

        var avatarInitialSelection = _this.setInitialAvatarValue(dirty, values);

        return react_1.default.createElement(components_lib_1.Steps, {
          activeStep: activeStep
        }, react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(__1.FormInputGroup, null, react_1.default.createElement(FormikConnected_1.default, {
          userNameValidation: userNameValidation,
          onUserNameValidated: _this.onUserNameValidationStateChange,
          formik: __assign({}, props)
        }), react_1.default.createElement(components_lib_1.FormInput, __assign({
          placeholder: enums_1.FieldPlaceHolders.userName,
          name: enums_1.FieldNames.userName,
          label: enums_1.FieldLabels.userName,
          onBlur: function onBlur() {
            _this.validateUserName(props);
          },
          onChangeText: function onChangeText() {
            _this.onUserNameChanged(props);
          },
          linkedField: enums_1.FieldNames.userNameValid,
          isLoading: waitingForUserNameValidation,
          isDisabled: waitingForUserNameValidation,
          accessibilityLabel: "Enter your username"
        }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
          placeholder: enums_1.FieldPlaceHolders.password,
          name: enums_1.FieldNames.password,
          label: enums_1.FieldLabels.password,
          accessibilityLabel: "Enter your password",
          isSecure: true
        }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
          placeholder: enums_1.FieldPlaceHolders.passwordConfirm,
          name: enums_1.FieldNames.passwordConfirm,
          label: enums_1.FieldLabels.passwordConfirm,
          accessibilityLabel: "Confirm your password",
          isSecure: true
        }, props))), react_1.default.createElement(components_lib_1.ImagePickerContainer, {
          activeBreakpoint: activeBreakpoint
        }, react_1.default.createElement(components_lib_1.StyledInputLabel, null, enums_1.FieldLabels.avatar), react_1.default.createElement(components_lib_1.ImagePickerWithForm, __assign({
          collection: avatars,
          initialSelectedId: avatarInitialSelection,
          name: enums_1.FieldNames.avatar
        }, props))), react_1.default.createElement(TermsAndConditionsBox_1.default, __assign({
          showTerms: showTerms,
          showComplianceTerms: showComplianceTerms
        }, props)), react_1.default.createElement(styled_1.AuthButtonsContainer, null, react_1.default.createElement(components_lib_1.RowWrapper, null, react_1.default.createElement(components_lib_1.Button, {
          type: components_lib_1.ButtonTypeEnum.link,
          text: enums_1.FieldLabels.back,
          onPress: previousHandler,
          accessibilityLabel: enums_1.FieldLabels.back,
          uppercase: true
        }), react_1.default.createElement(components_lib_1.Button, {
          type: components_lib_1.ButtonTypeEnum.primary,
          text: enums_1.FieldLabels.continue,
          onPress: nextHandler,
          uppercase: true,
          accessibilityLabel: enums_1.FieldLabels.continue,
          disabled: _this.isContinueButtonDisabled(props)
        })))), react_1.default.createElement(__1.ShortPersonalDetailsForm, __assign({
          updating: updating,
          navigation: navigation,
          previousHandler: previousHandler,
          activeBreakpoint: activeBreakpoint,
          DateInputComponent: MaskedInputDate
        }, props)));
      }
    });
  };

  return UserNameRegistrationFormComponent;
}(react_1.Component);

exports.UserNameRegistrationFormComponent = UserNameRegistrationFormComponent;

var mapStateToProps = function mapStateToProps(state) {
  // todo to top level component
  var userNameValidation = store_1.userNameValidationSelector(state);
  var updating = store_1.authUpdatingSelector(state);
  return {
    userNameValidation: userNameValidation,
    updating: updating
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    registerUser: redux_1.bindActionCreators(store_1.registerSubmitActionCreator, dispatch),
    validUserNameCheck: redux_1.bindActionCreators(store_1.validUserNameCheckActionCreator, dispatch)
  };
};

var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var hoc = redux_1.compose(connector);
exports.default = hoc(UserNameRegistrationFormComponent);